/* eslint-disable react-compiler/react-compiler */
import { RouterProvider } from 'react-aria-components'
import { useHref, useNavigate } from 'react-router-dom'

// Custom hook that handles both external and internal URLs
function useCustomHref(to) {
  const reactRouterHref = useHref(to)

  // If it's an external URL, return it as-is
  if (to && (to.startsWith('http://') || to.startsWith('https://'))) {
    return to
  }

  // Otherwise, use React Router's processed href
  return reactRouterHref
}

export function ReactAriaProvider({ children }) {
  const navigate = useNavigate()

  return (
    <RouterProvider navigate={navigate} useHref={useCustomHref}>
      {children}
    </RouterProvider>
  )
}
